import { useTranslation } from 'react-i18next'
import { PermissionEntityType } from '@/api/model/permissionEntityType'
import { cn } from '@/lib/utils'
import { getEntityTypeLabels } from '../permissions.types'

interface Props {
  categories: PermissionEntityType[]
  selectedCategory: PermissionEntityType | null
  onSelectCategory: (category: PermissionEntityType) => void
}

export function CategoryListPanel({ categories, selectedCategory, onSelectCategory }: Props) {
  const { t } = useTranslation('permissions')
  const entityTypeLabels = getEntityTypeLabels(t)
  return (
    <div className="flex-1 min-w-0 flex flex-col border-r">
      <div className="px-4 py-3 border-b bg-muted/40">
        <p className="text-sm font-semibold">{t('panels.categories.title')}</p>
      </div>
      <div className="flex-1 overflow-y-auto scrollbar-custom">
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => onSelectCategory(category)}
            className={cn(
              'w-full text-left px-4 py-2.5 text-sm hover:bg-muted transition-colors border-b border-border/50',
              selectedCategory === category && 'bg-muted font-medium'
            )}
          >
            {entityTypeLabels[category]}
          </button>
        ))}
      </div>
    </div>
  )
}
